import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService } from '../../services/loading.service';
import { CommonModule } from '@angular/common';
import { DomUtil } from '../../utils/dom.util';

@Component({
  selector: 'app-loading',
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent implements OnInit {
  private modalService = inject(NgbModal);
  private loadingService = inject(LoadingService);
  private cdr = inject(ChangeDetectorRef);

  message?: string;
  modalRef?: NgbModalRef;
  private closeTimeout?: any;
  @ViewChild('templateLoading') template!: TemplateRef<any>;

  ngOnInit(): void {
    this.loadingService.onLoading.subscribe({
      next: (value: { isLoading: boolean; message?: string }) => {
        // Cancela o timeout de fechamento se houver
        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
          this.closeTimeout = undefined;
        }

        if (!value.isLoading) {
          // Adiciona um pequeno delay para evitar fechar muito rápido
          this.closeTimeout = setTimeout(() => {
            this.close();
          }, 350);
        } else if (value.isLoading) {
          this.message = value.message ? value.message : 'Carregando...';
          this.render();
        }

        this.cdr.markForCheck();
      },
    });
  }



  render() {
    new Promise<void>((resolve) => {
      this.close();
      resolve();
    }).then(() => {
      // Evita abrir múltiplos modais
      if (!this.modalRef) {
        this.modalRef = this.modalService.open(this.template, {
          centered: true,
          backdrop: 'static',
          keyboard: false,
          animation: true,
          size: 'sm',
        });
      }
    });
  }

  close() {
    if (this.modalRef != undefined) {
      this.modalRef?.close();
      this.modalRef = undefined;
      // Garante que a barra de rolagem volte se o ng-bootstrap falhar na limpeza
      DomUtil.cleanupBodyAfterModal();
    }
  }
}
